<mat-accordion class="accordion-section">
  <ng-container *ngFor="let faq of faqData">
    <mat-expansion-panel class="accordion-cont">
      <mat-expansion-panel-header class="accordion-header">
        <mat-panel-title class="header-title">{{faq.questions}}</mat-panel-title>
      </mat-expansion-panel-header>
      <ng-template matExpansionPanelContent class="acc-body">
        <div class="accordion-body" [innerHtml]="faq?.answers"></div>  
      </ng-template>
    </mat-expansion-panel>
  </ng-container>
</mat-accordion>